<template>
  <div>
    <h3 class="text-xl mb-6">Dietary Requirements</h3>
    <p class="text-xs mb-6">Please state any dietary requirements of allergies for your attendees:</p>
    <table v-if="!(order.additional_users.length === 0 && order.exclude_current_user)" class="w-full leading-normal">
      <tbody v-if="!order.exclude_current_user" class="border-b border-transparent">
        <tr><td colspan="2" class="align-top text-sm font-bold">{{ order.first_name + ' ' + order.last_name }}</td></tr>
        <tr><td colspan="2" class="align-top text-sm">{{ order.email }}</td></tr>
        <tr class="border-bottom">
          <td class="text-sm pb-4">
            Dietary Requirements: {{ order.dietary_requirements ? order.dietary_requirements : 'None' }} /
            Allergies: {{ order.allergies ? order.allergies : 'None'}}
          </td>
          <td class="text-sm pb-4 text-right">
            {{ ticket.price_after_discount | gbp }}
          </td>
        </tr>
      </tbody>
      <tbody v-for="(registrant, i) in order.additional_users" :key="i" class="border-b border-transparent">
        <tr><td colspan="2" class="align-top text-sm font-bold">{{ registrant.first_name + ' ' + registrant.last_name }}</td></tr>
        <tr><td colspan="2" class="align-top text-sm">{{ registrant.email }}</td></tr>
        <tr class="border-bottom">
          <td class="text-sm pb-4">
            Dietary Requirements: {{ registrant.dietary_requirements ? registrant.dietary_requirements : 'None' }} /
            Allergies: {{registrant.allergies ? registrant.allergies : 'None'}}
          </td>
          <td class="text-sm pb-4 text-right">
            {{ ticket.price_after_discount | gbp }}
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else>No attendee is added.</p>
  </div>
</template>
<script>

export default {
  props: ['event', 'ticket', 'order', 'errorBag'],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
